import { render, staticRenderFns } from "./ThemesEditorNavLink.vue?vue&type=template&id=2deb3632"
import script from "./ThemesEditorNavLink.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemesEditorNavLink.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports